import "../../../../assets/presentation/components/controls/ripple/ripple-C_NchMu3.css";
import { sleep } from "../../../../infrastructure/sleep.js";
/* empty css       */
import classNames from "classnames";
import React, { createElement, useEffect, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/controls/ripple/ripple.tsx
var ANIMATION_DURATION = 360;
var RippleCircle = ({ left, top, isRippling }) => isRippling ? /* @__PURE__ */ jsx("span", {
	className: "ripple-circle",
	style: {
		animationDuration: `${ANIMATION_DURATION}ms`,
		left,
		top
	}
}) : null;
var Ripple = ({ className, component = "div", onClick, children, light, dark, isDisabled, style, ...otherProps }) => {
	const [isRippling, setIsRippling] = useState(false);
	const [left, setLeft] = useState(-1);
	const [top, setTop] = useState(-1);
	const onComponentClick = async (event) => {
		const { left, top } = event.currentTarget.getBoundingClientRect();
		setLeft(event.clientX - left);
		setTop(event.clientY - top);
		await sleep(ANIMATION_DURATION / 3).then(() => {
			onClick?.(event);
		});
	};
	useEffect(() => {
		let timeout = 0;
		if (top >= 0 && left >= 0) {
			setIsRippling(true);
			timeout = setTimeout(() => {
				setIsRippling(false);
				timeout = 0;
			}, ANIMATION_DURATION);
			return () => {
				clearTimeout(timeout);
			};
		} else setIsRippling(false);
	}, [top, left]);
	useEffect(() => {
		if (!isRippling) {
			setLeft(-1);
			setTop(-1);
		}
	}, [isRippling]);
	return createElement(component, {
		className: classNames(className, "ripple", {
			"ripple-dark": dark,
			"ripple-light": light
		}),
		onClick: onComponentClick,
		disabled: isDisabled,
		style,
		...otherProps
	}, /* @__PURE__ */ jsxs(React.Fragment, { children: [children, /* @__PURE__ */ jsx(RippleCircle, {
		isRippling,
		left,
		top
	})] }));
};
//#endregion
export { Ripple };

//# sourceMappingURL=ripple2.js.map